/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// TODO Unit testy.
/**
 * Poskytovatel zdrojů pro zobrazování HTML video elementů.
 * Implementuje návrhový vzor Object pool pro tvorbu zdrojů.
 * Provádí recyklaci vrácených zdrojů pro další použití.
 * @implements {ViewerSourceCreator}
 */
class ViewerSourceVideoCreator {
  /**
   * Vytvoří instanci.
   * @param {PoolFactory} poolFactory
   * @param {HtmlVideoRepairer} repairer
   * @param {ViewerSourceFactory} sourceFactory Továrna na zdroje, které se poskytují.
   */
  constructor(poolFactory, repairer, sourceFactory) {
    this.pool = poolFactory.create(sourceFactory);
    this.repairer = repairer;
    this.sourceFactory = sourceFactory;
  }

  /** @inheritdoc */
  delete(source) {
    // Při odebírání velkého počtu video elementů z DOM dochází ve většině prohlížečů k paměťovým únikům.
    // Proto se místo odebrání provede pokus o vyčištění zdroje a jeho následné vrácení do pool pro další použití.
    return new Promise((resolve) => {
      source.getFrame().repair();
      return resolve(
        this.repairer
          .repair(source.getEl())
          .then(() => this.pool.receive(source))
      );
    });
  }

  /** @inheritdoc */
  destroy() {
    this.pool.destroy();
  }

  /** @inheritdoc */
  getLent() {
    return this.pool.getLent();
  }

  /** @inheritdoc */
  getMax() {
    return this.pool.getMax();
  }

  /** @inheritdoc */
  lend(parentEl, scheduleInfo) {
    return new Promise((resolve) => {
      // Nastaví se rodičovský element továrny, aby do něj vytvářela nové zdroje.
      // Nastavuje se dopředu, aby byl rodičovský element dostupný v okamžiku plnění bazénu.
      this.sourceFactory.setParentEl(parentEl);
      // Vypůjčení zdroje z bazénu.
      const source = this.pool.lend();
      // Nastaví se rodičovský element továrny, aby do něj vytvářela nové zdroje.
      // Nastavuje se duplicitně, protože není jistota, že datový zdroj vytvoří továrna.
      // Může dojít k recyklaci a zdroj může mít nastaven starý rodičovský element.
      source.setParentEl(parentEl);
      return resolve(source);
    });
  }

  /** @inheritdoc */
  receive(source) {
    return new Promise((resolve) =>
      resolve(
        this.repairer
          .repair(source.getEl())
          .then(() => this.pool.receive(source))
      )
    );
  }

  /** @inheritdoc */
  replace() {
    // Není třeba nic provést.
    return Promise.resolve();
  }
}

export default ViewerSourceVideoCreator;
